import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export type UnskipOrderResponse = never;

export interface UnskipOrderData {
  id: number;
  source: string;
}

export function postUnskipOrder(data: UnskipOrderData) {
  return send<UnskipOrderResponse>({
    path: '/api/unskip_order/',
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: data,
  });
}
